/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { Dimensions, StyleProp, View, ViewStyle } from "react-native";

import { skaleWhite } from "config/UpduoColors";

const windowWidth = Dimensions.get("window").width;

interface UpduoCardProps {
  borderRadius?: number;
  backgroundColor?: string;
  widthRatio?: number;
  paddingTop?: number;
  paddingBottom?: number;
  paddingRight?: number;
  paddingLeft?: number;
  flex?: number;
  marginBottom?: number;
  square?: boolean;
  height?: number;
  style?: StyleProp<ViewStyle>;
}

export default function UpduoCard({
  borderRadius = 4,
  backgroundColor = skaleWhite,
  widthRatio = 0.9,
  paddingTop = 0,
  paddingBottom = 0,
  paddingRight = 0,
  paddingLeft = 0,
  flex = 0,
  marginBottom = windowWidth * 0.05,
  square = false,
  style,
  children,
}: React.PropsWithChildren<UpduoCardProps>) {
  return (
    <View
      style={[
        {
          alignSelf: "center",
          flex: flex,
          paddingTop: paddingTop,
          paddingBottom: paddingBottom,
          paddingRight: paddingRight,
          paddingLeft: paddingLeft,
          marginBottom: marginBottom,
          width: windowWidth * widthRatio,
          backgroundColor: backgroundColor,
          borderRadius: borderRadius,
          height: square ? windowWidth * widthRatio : undefined,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
}
